
function lerp(x: number, x0: number, x1: number, y0: number, y1: number) {
  return y0 + (x - x0) * (y1 - y0) / (x1 - x0)
}

function rgb_to_string(rgb: number[]) {
  const t = rgb.map(v => v.toFixed(2)).join(",")
  return `rgba(${t})`
}

export class Colormap {
  rgb: any;
  val: number[]
  min: number;
  max: number;
  vmin: number;
  vmax: number;
  constructor(values: any) {
    this.val = values.map(v => v[0])
    this.rgb = values.map(v => v[1])
    this.vmin = Math.min(...this.val)
    this.vmax = Math.max(...this.val)
  }
  limits(min: number, max: number) {
    this.min = min
    this.max = max
  }
  at(value: number) {
    let x0 = (value - this.min) / (this.max - this.min) // 0 to 1
    let x = x0 * (this.vmax - this.vmin) + this.vmin
    if (x < this.vmin)
      return rgb_to_string(this.rgb[0])
    if (x > this.vmax)
      return rgb_to_string(this.rgb.at(-1))
    for (let i = 0; i < this.val.length - 1; i++) {
      if (x >= this.val[i] && x <= this.val[i + 1]) {
        let rgb = [0, 1, 2, 3].map(k => lerp(x,
          this.val[i], this.val[i + 1],
          this.rgb[i][k], this.rgb[i + 1][k]))
        return rgb_to_string(rgb)
      }
    }
  }
}
